import React, { FC, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ButtonTypes, IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { ButtonToggles } from '@eika/radio-button';

import { ValgtWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import ETakstFormData from './eTakstFormData';
import ETakstInfoModal from './eTakstInfoModal';

const EtakstValg: FC = () => {
    const { etakst, button, validationMessage } = useTranslation();
    const {
        control,
        setValue,
        unregister,
        formState: { errors },
    } = useFormContext<ETakstFormData>();
    const [showModal, setShowModal] = useState<boolean>(false);
    const onChangeHarEtakst = (value: ValgtWeb) => {
        if (value === ValgtWeb.NEI) {
            unregister('eTakst');
        }
        setValue('harETakst', value);
    };

    return (
        <>
            <ETakstInfoModal showModal={showModal} setShowModal={setShowModal} />
            <Controller
                name="harETakst"
                control={control}
                rules={{
                    validate: {
                        ikkeValgtETakst: (value: ValgtWeb) => value !== ValgtWeb.IKKE_VALGT,
                    },
                }}
                render={({ field: { value } }) => (
                    <ButtonToggles
                        label={etakst.togglesLabel}
                        sublabel={etakst.togglesSublabel}
                        data-track-id="kreditt-boliglaan-etakst-valg-har-etakst"
                        data-track-linkname={value}
                        onChange={(value) => onChangeHarEtakst(value as ValgtWeb)}
                        infoButton={
                            <IconButton
                                className="sgw-radio-icon"
                                icon={IconTypes.INFO_24}
                                screenReaderText={button.iconButtonInformasjon}
                                buttonType={ButtonTypes.ICON}
                                onClick={() => setShowModal(true)}
                            />
                        }
                        selectedOption={value}
                        options={[
                            { label: button.ja, value: ValgtWeb.JA },
                            { label: button.nei, value: ValgtWeb.NEI },
                        ]}
                        errorMessage={
                            errors.harETakst?.type === 'ikkeValgtETakst' ? `${validationMessage.requiredChoose}` : ''
                        }
                    />
                )}
            />
        </>
    );
};

export default EtakstValg;
